import { render, staticRenderFns } from "./SortPanel.vue?vue&type=template&id=65d67842&scoped=true"
import script from "./SortPanel.vue?vue&type=script&lang=js"
export * from "./SortPanel.vue?vue&type=script&lang=js"
import style0 from "./SortPanel.vue?vue&type=style&index=0&id=65d67842&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d67842",
  null
  
)

export default component.exports